import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, shareReplay, tap } from 'rxjs';
import { Budget, Urgency } from 'src/app/job/models/job-post/job.model';
import { GeneralSettings } from 'src/app/settings/models/general-settings.model';
import { OwnerSettings } from 'src/app/settings/models/owner-settings.model';
import { PropertyManagerSettings } from 'src/app/settings/models/property-manager-settings.model';
import { TenantSettings } from 'src/app/settings/models/tenant-settings.model';
import { TradeSettings } from 'src/app/settings/models/trade-settings.model';
import { Events } from 'src/app/shared/constants/events.constant';
import { environment } from 'src/environments/environment';
import { BaseService } from '../base/base.service';
import { EventService } from '../event.service';

@Injectable({
  providedIn: 'root',
})
export class SettingsService extends BaseService {
  private readonly urlPrefix = `${environment.agencyMgmt.urlPrefix}/settings`;

  constructor(http: HttpClient, private eventService: EventService) {
    super(http);
  }

  public getBudget() {
    return this.get<Budget>(`${this.urlPrefix}/budget`);
  }

  public getUrgency() {
    return this.get<Urgency>(`${this.urlPrefix}/urgency`);
  }

  public getBudgetOptions() {
    return this.get<Budget[]>(`${this.urlPrefix}/budget-options`);
  }

  generalSettings$: Observable<GeneralSettings>;
  public generalSettings() {
    if (!this.generalSettings$) {
      this.generalSettings$ = this.get<GeneralSettings>(
        `${this.urlPrefix}/general`
      ).pipe(shareReplay(1));
    }
    return this.generalSettings$;
  }

  public clearGeneralSettingsCache() {
    if (this.generalSettings$)
      this.generalSettings$ = undefined;
  }

  public updateGeneralSettings(generalSettings: GeneralSettings) {
    return this.patch<GeneralSettings>(
      `${this.urlPrefix}/general`,
      generalSettings
    ).pipe(
      tap(() => {
        this.eventService.dispatch(Events.OrganizationSettingsChangedEvent);
      })
    );
  }
  public ownerSettings() {
    return this.get<OwnerSettings>(`${this.urlPrefix}/owner`);
  }

  public updateOwnerSettings(ownerSettings: OwnerSettings) {
    return this.patch<OwnerSettings>(`${this.urlPrefix}/owner`, ownerSettings);
  }
  public tenantSettings() {
    return this.get<TenantSettings>(`${this.urlPrefix}/tenant`);
  }

  public updateTenantSettings(tenantSettings: TenantSettings) {
    return this.patch<TenantSettings>(
      `${this.urlPrefix}/tenant`,
      tenantSettings
    );
  }
  public tradeSettings() {
    return this.get<TradeSettings>(`${this.urlPrefix}/trade`);
  }

  public updateTradeSettings(tradeSettings: TradeSettings) {
    return this.patch<TradeSettings>(
      `${this.urlPrefix}/trade`,
      tradeSettings
    ).pipe(
      tap(() => {
        this.eventService.dispatch(Events.OrganizationSettingsChangedEvent);
      })
    );
  }

  public getJobSortType() {
    return this.get<number>(`${this.urlPrefix}/jobSortType`);
  }

  public updateJobSortTypes(sortType: number) {
    return this.patch<boolean>(
      `${this.urlPrefix}/jobSortType`,
      { sortType }
    )
  }
  public AuthrizeRealtyUrl() {
    return this.get<string>(`${this.urlPrefix}/Integrations/realty-assist/authorize`);
  }
}
